<template>
    <div>
      <v-data-table
        :headers="headers"
        :items="getAllItems"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top >
          <v-toolbar flat color="white" >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar..."
            single-line
            hide-details
          ></v-text-field>
          <v-btn color="green" small outlined @click="descargarExcel"><v-icon color="green">mdi-microsoft-excel</v-icon></v-btn>
          <v-spacer></v-spacer>        
            <v-btn color="primary" dark class="mb-2" @click="rutas()">NUEVO</v-btn>         
            <!-- <v-btn color="primary" dark class="mb-2" to="/compras/generar">+</v-btn>          -->
          </v-toolbar>
        </template>
        <template v-slot:[`item.fecha`]="{ item }">
          {{item.fecha | formatoFecha}}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mr-2 mdi-24px" @click="eliminarFactura(item)" color="red" >mdi-close-circle-outline</v-icon>
          <v-icon class="mr-2 mdi-24px" @click="mostrar(item)" color="teal" >mdi-file-eye-outline</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Recargar</v-btn>
        </template>
      </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import {json2excel} from 'js2excel';

export default {
     data: () => ({
      title:'COMPRAS',
      search:'',
      headers: [       
        { text: 'Fecha', value: 'fecha' },
        { text: 'Proveedor',align: 'left', value: 'cliente',width: '40%'},      
        { text: 'Serie',align: 'left', value: 'serie',width: '10%' },      
        { text: 'Numero',align: 'center', value: 'numero'},       
        { text: 'Documento',align: 'center', value: 'documento'},      
        { text: 'Descuento',align: 'center', value: 'descuento'},      
        { text: 'Total',align: 'center', value: 'total'},      
        { text: 'Estado',align: 'center', value: 'estado',sortable: false, },
        { text: 'Opciones',align: 'center', value: 'actions', sortable: false },
      ],
      itemslist: [],
    }),

    async created () {
      await this.initialize()
    },
    computed: {
      getAllItems () {
        return this.$store.getters.getAllVentas
      },
      getTokenUser(){
      return this.$store.getters.getTokenUser
    }
    },
    methods: {
      async initialize () {
       await  this.$store.dispatch('setAllCompras')       
      }, 
      rutas(){
          this.$router.push({name:'facturascompras'})
      },
       async eliminarFactura(item) {       
         Swal.fire({
          title: 'ELIMINAR FACTURA',
          text:'Escriba el motivo de la anulación',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Eliminar!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.isConfirmed) {       
             this.eliminarFac(item)
          }
        })
                 
      },
      mostrar(item){
        this.$router.push(`/mostrar/${item.idfactura}`)
      },
      async eliminarFac(item){
                await axios.put(`${this.$store.getters.getUrlApi}/facturas/anularcompra/${parseInt(item.idfactura)}/${parseInt(item.idestablecimiento.idestablecimiento)}`,{},this.getTokenUser).then(()=>{      
              this.alertDone('Factura Anulada')
              this.initialize()          
        }).catch(()=>{this.errorSwal('Error al anular la factura') })
      },   
      
      descargarExcel(){
        const elementos = []
        this.getAllItems.map(function(item) {         
          item.total = parseFloat(item.total)
          item.descuento = parseFloat(item.descuento)
          elementos.push(item)
        })

        const data = elementos
        try {
            json2excel({
                data,
                name: 'Reporte_Compras',
                formateDate: 'yyyy/mm/dd'
            });
        } catch (e) {
            console.error('export error');
        }
      },

      //Notificaciones Swal
      alertDone(message){
        Swal.fire({
          icon: 'success',
          title: message,
          showConfirmButton: false,
          timer: 1500
        })
      },
      errorSwal(message){
        Swal.fire({
          icon: 'error',
          title: message,        
        })
      }
    },

  filters: {
    formatoFecha: function (value) {
      if (!value) return ''
      return moment(value).format('DD/MM/YYYY')
    }
  }
    
}
</script>
